import './CustomStepper.scss';
import { useEffect, useRef } from 'react';

const CheckIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="3"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <polyline points="20 6 9 17 4 12" />
  </svg>
);

const CustomStepper = ({ steps, activeStep, onStepClick }) => {

  const stepperRef = useRef(null);
  const activeStepRef = useRef(null);

  useEffect(() => {
    if (activeStepRef.current && activeStep === 2) {
      activeStepRef.current.scrollIntoView({
        behavior: 'smooth',
        block: 'nearest',
        inline: 'end'
      });
    }
  }, [activeStep]);

  const handleStepClick = (index) => {
    if (index < activeStep && onStepClick) {
      onStepClick(index + 1);
    }
  };

  return (
    <div className="custom-stepper" data-testid="custom-stepper">
      {steps.map((label, index) => {
        const isCompleted = index < activeStep;
        const isActive = index === activeStep;
        const isPending = index > activeStep;

        const barClasses = `custom-stepper__bar ${
          isCompleted || isActive 
            ? 'custom-stepper__bar--active' 
            : 'custom-stepper__bar--pending'
        }`;

        const labelClasses = `custom-stepper__label ${
          isActive
            ? 'custom-stepper__label--active'
            : 'custom-stepper__label--pending'
        }`;

        return (
          <div 
            key={index}
            ref={isActive ? activeStepRef : null}
            className="custom-stepper__item"
            onClick={() => handleStepClick(index)}
            style={{ cursor: isCompleted ? 'pointer' : 'default' }}
          >
            <div className="custom-stepper__step-wrapper">
              <div className={barClasses} />
              {isActive && (
                <div className="custom-stepper__circle custom-stepper__circle--active">
                  <span className="custom-stepper__number">{index + 1}</span>
                </div>
              )}
            </div>
            <div className={labelClasses}>{label}</div>
          </div>
        );
      })}
    </div>
  );
};

export default CustomStepper;

